import React from "react";
import Navbar from "./Navbar";

export default function PageLayout({ children, hideNav = false, className = "" }) {
  return (
    <div className="min-h-screen bg-[#F9F8F6] text-zinc-900">
      {!hideNav && <Navbar />}
      <main className={`max-w-7xl mx-auto px-5 lg:px-8 py-8 lg:py-12 ${className}`}>{children}</main>
    </div>
  );
}
